import logoImg from '../assets/logo.png';
import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-powered">Powered by</span>
          <img src={logoImg} alt="SWISO dev" className="footer-logo" />
          <span className="footer-company">Technology L.L.C.</span>
        </div>
        <div className="footer-right">
          <span>Confidential — Internal Use Only</span>
          <span className="footer-dot">·</span>
          <span>SDLC v2.0</span>
        </div>
      </div>
    </footer>
  );
}
